// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
production: false,
  page: 1,
  count: 0,
  tableSize: 2,
  baseBytes: 1000000, // Valor para usar en el helper ByteToMegaPipe
  maxFileSize: 100000000, // Equivale a 100 MB
  maxDocsFileSize: 10000000, // Equivale a 10 MB
  maxImagesFileSize: 1000000, // Equivale a 1 MB
  urlFooterImages: 'footer',
  defaultauth: 'fackbackend',
  urlProductImages: 'products',
  urlFanShopImages: 'fanshop',
  urlBulletinesImages: 'footer',
  urlCuttingToolsImages: 'cutting-tools',
  fileExtensionAllImages: 'image/*',
  fileExtensionOnlyDocs: '.doc,.pdf',
  fileMultimediaDir: 'detail-product-line',
  fileMultimediaExtension: 'image/*,video/*',
  fileExtension: 'image/*,video/*,.doc,.pdf',
  patternForOnlyText: '[a-zA-ZÁÉÍÓÚÑáéíóúñ0-9_ ]+',
  maxlengthForUrl: 200,
  maxlengthForButtons: 50,
  maxlengthForTitles: 100,
  maxlengthForContent: 2000,
  maxlengthForMenuTitles: 50,
  maxlengthForQuestions: 200,
  maxlengthForLanguages: 2000,
  timeForApplicationSync: 900000,
  baseApiUrl: "https://ngkntk-api.tgconsulting.online/ngk-api",
  monthsdeafault: 1,
firebaseConfig: {
  apiKey: '',
  authDomain: '',
  databaseURL: '',
  projectId: '',
  storageBucket: '',
  messagingSenderId: '',
  appId: '',
  measurementId: ''
  }
};

/*
* For easier debugging in development mode, you can import the following file
* to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
*
* This import should be commented out in production mode because it will have a negative impact
* on performance if an error is thrown.
*/
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
